import { render, staticRenderFns } from "./KnowledgeChecklist.vue?vue&type=template&id=5a7bd484"
import script from "./KnowledgeChecklist.vue?vue&type=script&lang=js"
export * from "./KnowledgeChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports